<template>
  <div class="DemandWriteDialog" >

    <CgModalMiddle
      @close="close"
      v-show="isShow"
    >
      <div slot="modal_content" class="modal-content">
        <div class="title">填写设计需求</div>
        <el-form :model="ruleForm" status-icon inline
                 :rules="rules" ref="ruleForm"
                 label-width="100px"
                 class="demo-ruleForm form">

          <div class="form-left">

            <el-form-item label="" prop="title">
              <div class="form-item-label"><i class="required">*</i>一句话描述你的需求</div>
              <el-input v-model="ruleForm.title" placeholder="描述你的需求" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="" prop="keyword">
              <div class="form-item-label"><i class="required">*</i>请输入你想要的素材关键词（请用空格隔开）</div>
              <el-input v-model="ruleForm.keyword" placeholder="请输入你想要的素材关键词" autocomplete="off"></el-input>
            </el-form-item>

            <div class="form-item-upload">
              <el-form-item class="" label="" prop="file">
                <div class="form-item-label"><i class="required">*</i>请上传案例素材参考 (最多上传4张，每张5M以内）</div>
                <el-upload
                  class="el-upload-box"
                  ref="upload"
                  accept="image/jpg,image/jpeg,image/png,image/gif"
                  :limit="4"
                  action="/"
                  list-type="picture-card"
                  :on-preview="handlePreview"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  :before-upload="beforeUpload"
                  :file-list="ruleForm.file"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>



              </el-form-item>

              <el-form-item class="form-item-case" label="">
                <el-input v-model="ruleForm.caseLink"
                          placeholder="请填写参考案例链接(选填)"
                          autocomplete="off"
                          class="textarea"
                          type="textarea"
                          resize="none"
                ></el-input>
              </el-form-item>
            </div>

          </div>

          <div class="form-right">
            <div class="form-item-type">
              <el-form-item label="" prop="categoryId">
                <div class="form-item-type-item">
                  <div class="form-item-label"><i class="required">*</i>请选择素材类型</div>
                  <!--              <el-input v-model="ruleForm.checkPass" placeholder="请选择素材类型" autocomplete="off"></el-input>-->
                  <el-select v-model="ruleForm.categoryId" placeholder="请选择素材类型">
                    <el-option
                      v-for="item in picType"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>

              </el-form-item>
              <el-form-item class="form-item-type" label="" prop="layoutId">
                <div class="form-item-type-item">
                  <div class="form-item-label"><i class="required">*</i>请选择素材格式</div>
                  <!--              <el-input v-model="ruleForm.checkPass" placeholder="请选择素材格式" autocomplete="off"></el-input>-->
                  <el-select v-model="ruleForm.layoutId" placeholder="请选择素材格式">
                    <el-option
                      v-for="item in picFormat"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </div>

            <el-form-item label="" prop="designStyle">
              <div class="form-item-label"><i class="required">*</i>请输入想要的设计风格</div>
              <el-input v-model="ruleForm.designStyle" placeholder="如剪纸风、弥散风" autocomplete="off"></el-input>
            </el-form-item>
            <!--          <el-form-item label="" prop="colorMode">
            <div class="form-item-label"><i class="required">*</i>请输入想要的颜色模式</div>
            <el-input v-model="ruleForm.colorMode" placeholder="请输入想要的颜色模式" autocomplete="off"></el-input>
          </el-form-item>-->
            <el-form-item label="" prop="qq">
              <div class="form-item-label"><i class="required">*</i>请填写联系电话或QQ</div>
              <el-input v-model="ruleForm.qq" placeholder="需求完成我们将第一时间通知您" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="" prop="otherDemand">
              <div class="form-item-label"><i class="required">*</i>请输入其他设计要求</div>
              <el-input
                class="textarea"
                v-model="ruleForm.otherDemand"
                type="textarea"
                placeholder="如营销文案、核心素材、设计排版、使用场景等，提升作图准确率"
                autocomplete="off"
                maxlength="100"
                show-word-limit
                resize="none"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="submit">
          <div class="submit-btn"
               @click="submitForm('ruleForm')"
          >
            提交需求
          </div>
        </div>
      </div>
    </CgModalMiddle>


    <CgModalMiddle
      @close="isShowSucc = false"
      v-if="isShowSucc"
    >
      <div slot="modal_content" class="modal-content2">
        <i class="iconfont icon-gou"></i>
        <div class="title">恭喜提交需求成功！</div>
        <div class="desc">我们在确认需求后会在最快的速度安排生产素材，
          具体请关注我的需求进度查看详情</div>
        <div class="submit-btn" @click="showWriteDialog">再提一个需求</div>
      </div>
    </CgModalMiddle>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>



  </div>
</template>

<script>
import {getMaterialClassify} from "@/api/material";
import {usageTypeList, menuList, typeList} from "@/components/list/module";
// const upyun = require("upyun");
import upyun from 'upyun'
import {getUpyunSign, submitDemandForm} from "@/api/fans/demand-pool";
const path = require("path");
var bucket = new upyun.Bucket('sdkimg')
import axios from "axios";
import DemandWriteSuccessDialog from "~/components/fans/demand-write-dialog/success-dialog";


export default {
  name: "DemandWriteDialog",
  data() {
    return {
      isShow: false,
      isShowSucc: false,
      ruleForm: {
        title: '',
        keyword: '',
        categoryId: '',
        layoutId: '',
        designStyle: '',
        // colorMode: '',
        caseLink: '',
        otherDemand: '',
        qq: '',
        file: [],
      },
      rules: {
        title: [
          {required: true, message: '请输入你的需求', trigger: 'blur'},
        ],
        designStyle: [
          {required: true, message: '请输入想要的设计风格', trigger: 'blur'},
        ],
        keyword: [
          {required: true, message: '请输入想要的设计风格', trigger: 'blur'},
        ],
        /*colorMode: [
          {required: true, message: '请输入想要的颜色模式', trigger: 'blur'},
        ],*/
        categoryId: [
          {required: true, message: '请选择素材类型', trigger: 'change'},
        ],
        layoutId: [
          {required: true, message: '请选择素材格式', trigger: 'change'},
        ],
        qq: [
          {required: true, message: '请填写联系电话或QQ', trigger: 'blur'},
        ],
        otherDemand: [
          {required: true, message: '请输入其他设计要求', trigger: 'blur'},
        ],
        file: [
          {
            message: '请先上传文件',
            trigger: 'change',
            required: true,
          },
        ],
      },
      imageUrl: [],
      imgeData: [],//图片列表
      formData: [],
      fileData: '', // 文件上传数据（多文件合一）
      fileList: [],  // upload多文件数组
      uploadData: {
        fieldData: {
          id: '', // 机构id,
        }
      },

      /* 图片类型 */
      picType: [],
      picFormat: [],
      dialogVisible:false,
      dialogImageUrl:'',

      tempSubmitQuery: {
        title: '',
        keyword: '',
        categoryId: '',
        layoutId: '',
        designStyle: '',
        colorMode: '',
        caseLink: '',
        otherDemand: '',
        qq: '',
      }
    }
  },
  components:{
    DemandWriteSuccessDialog
  },
  mounted() {
    // this.init();
  },
  watch:{
    isShow:{
      handler(n,o){
        if (n){
          this.$nextTick(()=>{
            if (this.$refs.ruleForm){
              this.resetForm('ruleForm')
            }
          })

          if (n == true){
            this.init()
          }
        }
      },
      immediate: true
    }
  },
  methods: {

    init() {
      this.getPicType()
      this.getPicFormat()
    },

    async getPicType() {
      let res = await getMaterialClassify({'home_keyword_id': 0, 'module': 0})
      this.picType = res.data.module_list.other_list
    },
    getPicFormat() {
      this.picFormat = usageTypeList
    },

    close() {
      /* 清空表单 */
      /* 关闭弹框 */
      this.isShow = false;
    },
    // 上传文件
    uploadFile(file) {

      console.log('uploadFile 上传文件')
      console.log(this.fileList)
      this.submitUpload();
      return

      this.fileData.append('files', this.fileList); // append增加数据
    },

    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    beforeUpload(file) {
      console.log(file)
    },

    // 上传到服务器
    async submitUpload() {
      console.log('--submitUpload--')
      // const fs = require("fs");
      let _fileList = [].slice.call(this.ruleForm.file);
      const PUBLIC_PATH = path.join(__dirname, "/");
      console.log(Array.isArray(_fileList))


      const bucketName = 'chaopx-pic'
      const service = new upyun.Bucket(bucketName, "qianku", "HCkj58BKu@2017");

      function _b64_hmac_sha1(k, d, _p, _z) {
        // heavily optimized and compressed version of http://pajhome.org.uk/crypt/md5/sha1.js
        // _p = b64pad, _z = character size; not used here but I left them available just in case
        if (!_p) {
          _p = '=';
        }
        if (!_z) {
          _z = 8;
        }

        function _f(t, b, c, d) {
          if (t < 20) {
            return (b & c) | ((~b) & d);
          }
          if (t < 40) {
            return b ^ c ^ d;
          }
          if (t < 60) {
            return (b & c) | (b & d) | (c & d);
          }
          return b ^ c ^ d;
        }

        function _k(t) {
          return (t < 20) ? 1518500249 : (t < 40) ? 1859775393 : (t < 60) ? -1894007588 : -899497514;
        }

        function _s(x, y) {
          var l = (x & 0xFFFF) + (y & 0xFFFF), m = (x >> 16) + (y >> 16) + (l >> 16);
          return (m << 16) | (l & 0xFFFF);
        }

        function _r(n, c) {
          return (n << c) | (n >>> (32 - c));
        }

        function _c(x, l) {
          x[l >> 5] |= 0x80 << (24 - l % 32);
          x[((l + 64 >> 9) << 4) + 15] = l;
          var w = [80], a = 1732584193, b = -271733879, c = -1732584194, d = 271733878, e = -1009589776;
          for (var i = 0; i < x.length; i += 16) {
            var o = a, p = b, q = c, r = d, s = e;
            for (var j = 0; j < 80; j++) {
              if (j < 16) {
                w[j] = x[i + j];
              } else {
                w[j] = _r(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
              }
              var t = _s(_s(_r(a, 5), _f(j, b, c, d)), _s(_s(e, w[j]), _k(j)));
              e = d;
              d = c;
              c = _r(b, 30);
              b = a;
              a = t;
            }
            a = _s(a, o);
            b = _s(b, p);
            c = _s(c, q);
            d = _s(d, r);
            e = _s(e, s);
          }
          return [a, b, c, d, e];
        }

        function _b(s) {
          var b = [], m = (1 << _z) - 1;
          for (var i = 0; i < s.length * _z; i += _z) {
            b[i >> 5] |= (s.charCodeAt(i / 8) & m) << (32 - _z - i % 32);
          }
          return b;
        }

        function _h(k, d) {
          var b = _b(k);
          if (b.length > 16) {
            b = _c(b, k.length * _z);
          }
          var p = [16], o = [16];
          for (var i = 0; i < 16; i++) {
            p[i] = b[i] ^ 0x36363636;
            o[i] = b[i] ^ 0x5C5C5C5C;
          }
          var h = _c(p.concat(_b(d)), 512 + d.length * _z);
          return _c(o.concat(h), 512 + 160);
        }

        function _n(b) {
          var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = '';
          for (var i = 0; i < b.length * 4; i += 3) {
            var r = (((b[i >> 2] >> 8 * (3 - i % 4)) & 0xFF) << 16) | (((b[i + 1 >> 2] >> 8 * (3 - (i + 1) % 4)) & 0xFF) << 8) | ((b[i + 2 >> 2] >> 8 * (3 - (i + 2) % 4)) & 0xFF);
            for (var j = 0; j < 4; j++) {
              if (i * 8 + j * 6 > b.length * 32) {
                s += _p;
              } else {
                s += t.charAt((r >> 6 * (3 - j)) & 0x3F);
              }
            }
          }
          return s;
        }

        function _x(k, d) {
          return _n(_h(k, d));
        }

        return _x(k, d);
      }

      function getUpyunUploadHeader(service, method, path) {
        path = '/' + service.serviceName + path;
        var date = new Date().toGMTString();
        var data = [method, path, date];
        var sign = _b64_hmac_sha1(service.password, data.join('&'));
        sign = 'UPYUN ' + service.operatorName + ':' + sign;
        return {
          'Authorization': sign,
          'X-Date': date
        };

      }

      function add0(m) {
        return m < 10 ? '0' + m : m;
      }

      function timestamp() {
        var time = new Date();
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        return y + add0(m) + add0(d) + add0(h) + add0(mm) + add0(s);
      }

      const client = new upyun.Client(service, getUpyunUploadHeader)

      _fileList.forEach(item => {
        item._time = timestamp();
        // item._picName = item._time + item.raw.name;
        item._picName = item._time;

        if (item._uploadStatus != 1){
          client.putFile(`/chaotu/portal_upload/${item._picName}`, item.raw, {
            'Content-Type': item.raw.type,
          }).then(res => {
            console.log(res)
            console.log(res.header)
            if (res === true || res.width > 0) {
              console.log("上传成功")
              item._remoteUrl = `/chaotu/portal_upload/${item._picName}`
              item._remoteUrl2 = `https://pic.chaopx.com/chaotu/portal_upload/${item._picName}`
              item.url = `https://pic.chaopx.com/chaotu/portal_upload/${item._picName}`
              item._uploadStatus = 1
              let img = new Image()
              item.status = 'success'

              img.src = item._remoteUrl2
              img.onload = () => {
                item._width = img.width;
                item._height = img.height;
              }
            }
          }).catch(err => {
            console.log(err)
          })
        }


      })
    },

    //移除
    handleRemove(file, fileList) {
      this.ruleForm.file = fileList;
      // return this.$confirm(`确定移除 ${ file.name }？`);
    },

    // 选取文件超过数量提示
    handleExceed(files, fileList) {
      this.$myNotify.error('当前限制选择 5 个文件')
      // this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },

    //监控上传文件列表
    handleChange(file, fileList) {

      this.ruleForm.file = fileList

      setTimeout(() => {
        console.log(11111)
        let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
        if (existFile) {
          // this.$message.error('当前文件已经存在!');
          this.$myNotify.error('当前文件已经存在!')
          fileList.pop();
        }

        for (let i = 0; i < fileList.length; i++) {
          let item = fileList[i]
          console.log(item.size)
          if (item.size / 1024 / 1024 > 5) {
            this.$myNotify.error('请检查，上传文件大小不能超过5MB!')
            fileList.pop();
            break;
          } else {

          }
        }
        this.submitUpload();

        this.ruleForm.file = fileList;



      },200)




    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          let pic = this.ruleForm.file;

          let caseMaterial = this.ruleForm.file.map((item) => {
            return {
              width: item._width,
              height: item._height,
              picUrl: item._remoteUrl,
            }
          })

          console.log(caseMaterial)

          // let _tempSubmitQuery = Object.assign(this.tempSubmitQuery, this.ruleForm)

          let {
            title,
            keyword,
            categoryId,
            layoutId,
            designStyle,
            caseLink,
            otherDemand,
            qq,
          } = this.ruleForm

          let _tempSubmitQuery = {
            title,
            keyword,
            categoryId,
            layoutId,
            designStyle,
            caseLink,
            otherDemand,
            qq,
          }
          _tempSubmitQuery.caseMaterial = caseMaterial


          submitDemandForm(_tempSubmitQuery).then(res => {
            console.log(res)

            let { status, message } = res.data;


            if (status == 200 ){
              // this.$myNotify.show(message)
              this.isShow = false;
              this.isShowSucc = true

              this.$emit('submitForm')
            }else if (status == 406 ){
              this.$myNotify.error(message)
            }else{
              this.$myNotify.error(message)
            }


          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    showWriteDialog(){
      this.resetForm('ruleForm')
      this.isShowSucc = false;
      this.isShow = true;

    }

  }
}
</script>

<style lang="scss" scoped>
.DemandWriteDialog {

  .modal-content {
    width: 872px;
    height: 688px;
    background: #FFFFFF;
    border-radius: 14px;
    padding: 36px 36px 32px;
    box-sizing: border-box;

    .title {
      height: 29px;
      font-size: 22px;
      font-weight: bold;
      color: #0A2540;
      line-height: 29px;
      margin-bottom: 25px;
    }
  }


  .form {

    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .form-left,
    .form-right{
      width: 376px;
    }

    .form-right{
      justify-content: flex-end;
    }

    .form-item-label {
      height: 19px;
      font-size: 14px;
      color: #2D2B33;
      line-height: 19px;
      margin-bottom: 10px;

      .required {
        width: 7px;
        height: 20px;
        font-size: 15px;
        color: #EE5253;
        line-height: 20px;
        margin-right: 6px;
      }
    }

    .el-form-item {
      width: 376px;

      &:nth-child(2n-1) {

      }

      /deep/ .el-input {
        width: 376px;
        background-color: #F5F6FA !important;
        border-radius: 8px;

        .el-input__inner {
          background-color: #F5F6FA !important;
          height: 52px;
          line-height: 52px;
          border-radius: 8px;
          border-color: transparent;
          padding: 0 16px !important;

          &::placeholder {
            color: rgba(45, 43, 51, 0.6);
          }

          &:focus {
            border-color: $color-fans;
          }
        }
      }

      /deep/ .el-form-item__error {
        padding-left: 16px;
      }

      /deep/ .textarea {
        width: 376px;
        height: 160px;
        background: #F5F6FA;
        border-radius: 8px;

        .el-textarea__inner {
          width: 100%;
          height: 100%;
          background-color: #F5F6FA !important;
          padding: 15px 16px 35px;
          box-sizing: border-box;
          border-color: transparent;

          &:focus {
            border-color: $color-fans;
          }

          &::placeholder {
            color: rgba(45, 43, 51, 0.6);
          }
        }

        .el-input__count {
          background-color: #F5F6FA !important;
        }


      }


    }

    .form-item-type {
      width: 376px;
      display: flex !important;

      /deep/ .el-form-item__content {
        display: flex !important;
      }

      .el-input {
        width: 179px;
      }

      /deep/ .el-select {
        .el-input {
          width: 179px;
        }
      }

      .form-item-type-item {
        display: flex;
        flex-direction: column;
        margin-right: 18px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .form-item-upload {
      display: flex;
      flex-direction: column;

      .el-upload-box {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }

      .el-upload-box{
        max-width: 384px;
        overflow: hidden;
        margin-bottom: 0;
      }

      /deep/ .el-upload-list {

        display: flex;
        //justify-content: space-between;
        .el-upload-list__item {
          width: 88px;
          height: 88px;
          background: #F5F6FA;
          border-radius: 8px;
          margin-bottom: 0;
        }
      }

      /deep/ .el-upload {
        width: 88px;
        height: 88px;
        background: #F5F6FA;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .form-item-case{

      }
    }
  }

  .submit {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    .submit-btn {
      width: 170px;
      height: 44px;
      background: $color-fans;
      border-radius: 24px;
      font-size: 14px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}

.modal-content2{
  width: 440px;
  height: 276px;
  background: #FFFFFF;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .icon-gou{
    font-size: 44px;
    color: $color-fans;
    margin: 40px 0 14px;
  }
  .title{
    height: 26px;
    font-size: 20px;
    font-weight: bold;
    color: #424866;
    line-height: 26px;
  }

  .desc{
    width: 340px;
    height: 40px;
    font-size: 14px;
    color: #596088;
    line-height: 20px;
    margin: 10px 0 30px;
  }

  .submit-btn{
    width: 140px;
    height: 44px;
    background: #FF5D6E;
    border-radius: 25px;
    text-align: center;
    line-height: 44px;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
    @include ElementHover('',$color-fans-hover)
  }
}

.el-input {
  background: #F5F6FA;
}

</style>
